// @mui material components
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

// Material Kit 2 React components
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import featured_article_img from 'assets/csdd_images/featured_article_final.jpg';


function FeaturedArticle() {
  return (
    <MKBox
      display='flex'
      alignItems='center'
      my={2}
      py={10}
      sx={{
        backgroundImage: ({
          functions: { linearGradient, rgba },
          palette: { gradients },
        }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.8),
            rgba(gradients.dark.state, 0.8)
          )}, url(${featured_article_img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top',
      }}
    >
      <Container>
        <Grid container item xs={12} lg={6} sx={{ ml: { xs: 0, lg: 6 } }}>
          <MKTypography mb={1} variant='h4' color='light' fontWeight='medium'>
          The Advocacy body of Suppliers, Professionals and Practitioners in the Procurement Space
          </MKTypography>
          <MKTypography variant='body2' color='light' opacity={0.9} mb={2}>
            The CSDD serves as the lobby and advocacy body for Suppliers and
            Procurement Professionals and Practitioners both in the Private and
            Public Sectors. The CSDD also functions as an industry research and
            development unit committed to enhancing members overall viability
            and the sustainability of Global Procurement Standards.
          </MKTypography>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FeaturedArticle;
